<template>
  <v-row>

    <v-col cols="12" sm="6" md="4" lg="3">
      <v-card
        @click="loadTool('tools-debt-snowball')"
      >
        <v-card-title>
          Debt Snowball
        </v-card-title>
        <v-card-text>
          Calculate and visualize the best way to pay off debts
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3">
      <v-card
        @click="loadTool('tools-truth-calculator')"
      >
        <v-card-title>
          Truth Calculator
        </v-card-title>
        <v-card-text>
          Calculate the interest rate required to hit a financial target
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3">
      <v-card
        @click="loadTool('tools-wealth-enhancer')"
      >
        <v-card-title>
          Wealth Enhancer
        </v-card-title>
        <v-card-text>
          Simulate daily cash value vs daily interest charges on policies
        </v-card-text>
      </v-card>
    </v-col>

  </v-row>
</template>

<script>
export default {
  name: 'ToolsIndex',
  data: () => ({

    headers: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
        width: '80px'
      },
      {
        text: 'Name',
        align: 'start',
        value: 'user.full_name',
      },
    ],
    
  }),
  methods: {
   loadTool( tool ) {
     this.$router.push({name: tool})
   }
    
  }
}
</script>